import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useCommunityList } from "Api/Coordinator/Verzoeken/Planboard";
import { useSendSMS } from "Api/Coordinator/Gebruikers/GebruikerView";

const SendSMS = () => {

	const [selectedCommunity, setSelectedCommunity] = useState("");
	const [communityError, setCommunityError] = useState(false);
	const { userDetails, setFilterCommunity } = useGebruikerContext();
	const data = userDetails?.profileList;
	const [description, setDescription] = useState("");
	const currentLength = description?.length ?? 0;
	const credits = Math.max(0, Math.ceil(currentLength / 160));
	const remainingChars = 1377 - currentLength;
	const { trigger: sendSMS, isMutating: isSendingSMS } = useSendSMS();

	const { data: communityResponse } = useCommunityList();

	const communities = communityResponse?.data

	useEffect(() => {
		setDescription(prev => prev || data?.tSms || "");
	}, [data]);

	useEffect(() => {
		if (communities?.length > 0 && !selectedCommunity) {
			setSelectedCommunity(String(communities[0].iCommunityId));
			setFilterCommunity([communities[0]]);
		}
	}, [communities]);

	const SendSMS = () => {
		if (!selectedCommunity) {
			setCommunityError(true);
			return;
		}

		if (!data?.iMobileNumber) {
			toast.error("Mobiel nummer is verplicht.");
			return;
		}
    	const payload = {
			type: "sms",
			sendTo: data?.iMobileNumber,
			iCredits: credits,
			content: description,
			iCommunityId: selectedCommunity,
			iChar: description?.length
		};

		sendSMS({data:payload})
			.then((response) => {
				if (response?.status) {
					toast.success(response.message);
					setDescription("");
				} else {
					toast.error(response.message);
				}
			})
			.catch((error) => {
				toast.error("Sms kan niet worden verzonden");
			});
	};

	return (
		<Card className="main-card">
			<CardBody className="d-flex flex-column sms">
				<Col>
					<h5 className="mb-4">SMS versturen</h5>
					<Input
						type="textarea"
						name="vMemo"
						id="vMemo"
						rows={9}
						maxLength={1377}
						className="text-area-input"
						value={description}
						onChange={(e) => setDescription(e.target.value)}
					/>
				</Col>

				<Row className="mt-3 align-items-center">
					{/* Left side */}
					<Col md={6} className="d-flex align-items-center">
						<p className="me-3 mb-0"> Aantal tekens / SMS :</p>						
							 {remainingChars}/ {credits}
						
					</Col>

					{/* Dropdown */}
					<Col md={3}>
						<select
							className={`form-select remaining-chars ${communityError ? "error-border" : ""
								}`}
							value={selectedCommunity}
							onChange={(e) => {
								const communityId = e.target.value;

								setSelectedCommunity(communityId);
								setCommunityError(false);

								if (communityId) {
									const community = communities.find(
										(item) => String(item.iCommunityId) === communityId
									);

									setFilterCommunity(community ? [community] : []);
								} else {
									setFilterCommunity([]);
								}
							}}
						>

							{communities?.map((item) => (
								<option key={item.iCommunityId} value={item.iCommunityId}>
									{item.name}
								</option>
							))}
						</select>
					</Col>

					{/* Button */}
					<Col md={3} xs="auto">
						<Button
							outline
							className={`btn-outline-primary-blue submit-btn w-100 flex ${description?.length > 1 ? "" : "disabled"
								}`}
							onClick={SendSMS}
							type="button"
							color="primary"
						>
							Verzenden
						</Button>
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
};

export default SendSMS;
